<div class="row-select">
    <h3>Selecione o email</h3>
    <div class="error" *ngIf="error">{{errorMsg}}</div>
    <hr />
    <div class="list-company">
      <div class="box-company" *ngFor="let email of emails" (click)="selectEmail(email)">
        {{email.email}}
      </div>
    </div>
</div>